const quotes = [
    "Strength does not come from physical capacity. It comes from an indomitable will.",
    "Success usually comes to those who are too busy to be looking for it.",
    "If you want something you've never had, you must be willing to do something you've never done.",
    "The body achieves what the mind believes.",
    "Once you are exercising regularly, the hardest thing is to stop it.",
    "The best way to predict the future is to create it.",
    "Rome wasn't built in a day, but they worked on it every single day.",
    "All progress takes place outside the comfort zone.",
    "What seems impossible today will one day become your warm-up.",
    "Go the extra mile. It's never crowded."
]

export default quotes;